import Papa from "papaparse";
import { getDatabase, ref, get } from "firebase/database";

// Loads admin levels from Firebase (uploaded CSV file)
export const fetchAdminLevels = async () => {
  const db = getDatabase();
  const snapshot = await get(ref(db, "uploads/adminLevels"));

  if (!snapshot.exists()) return {};

  const raw = snapshot.val();
  const csvText = typeof raw === "string" ? raw : raw.content; // <-- FIX

  const parsed = Papa.parse(csvText, {
    header: true,
    skipEmptyLines: true,
    delimiter: ";",
  }).data;

  const adminMap = {};
  parsed.forEach((row) => {
    const level = parseInt(row.adminLevel);
    const email = row.email?.trim().toLowerCase();
    if (level && email) adminMap[email] = level;
  });

  return adminMap;
};

// Simple email validation and classification
export const isAllowedDomain = (email) =>
  email.endsWith("@uevora.pt") || email.endsWith("@alunos.uevora.pt");

export const getUserType = (email) =>
  email.endsWith("@alunos.uevora.pt") ? "students" : "faculty";

// Gets admin level from map
export const getAdminLevel = (email, adminMap) =>
  adminMap[email.toLowerCase()] || 0;

export const isAdmin = (email, adminMap) => getAdminLevel(email, adminMap) > 0;

